var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticClass:"bg-transparent",attrs:{"src":`https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=${_vm.id}&size=130`}})
}
var staticRenderFns = []

export { render, staticRenderFns }